import React from 'react';

/* ============================================================================
   BAYRAKLAR — TR ve ABD, SATIR İÇİ SVG
   ----------------------------------------------------------------------------
   NEDEN EMOJİ DEĞİL
   Emoji bayrak (U+1F1F9 U+1F1F7 gibi bölgesel gösterge çiftleri) bir yazı
   tipi özelliğidir, resim değil. Windows'un
   Segoe UI Emoji yazı tipinde bayrak glifleri YOKTUR: Windows 10 ve 11'de bu
   karakterler bayrak olarak değil, iki harfli kutu ("TR", "US") olarak çizilir.
   Yani masaüstü kullanıcılarının çok büyük bölümünde bayrak hiç görünmezdi.
   Selçuk'un şartı buydu: "asla bazılarında gözükmemezlik olmayacak."

   NEDEN <img> DEĞİL
   Dış dosya bir ağ isteği demek. İstek yavaşsa bayrak geç gelir, CDN
   erişilemezse hiç gelmez ve yerinde kırık bir simge kalır. Satır içi SVG
   sayfayla birlikte gelir; ayrı bir başarısızlık noktası yoktur.

   NEDEN <use> DEĞİL
   50 yıldız <use href="#..."> ile tekrarlanabilirdi ama `href` (xlink'siz
   biçim) eski WebKit sürümlerinde çizilmez ve o tarayıcılarda kanton bomboş
   mavi kalırdı. Yıldızların tamamı TEK bir `d` dizgesinde, doğrudan koordinat
   olarak duruyor: hiçbir tarayıcı özelliğine bağlı değil.

   NEDEN currentColor DEĞİL
   Bayrak renkleri sabit yazıldı. `currentColor` kullanılsaydı bayrak, içinde
   bulunduğu düğmenin metin rengini alırdı ve koyu temada beyaz-üstü-beyaz
   ya da açık temada görünmez hâle gelebilirdi. Bayrağın rengi temaya bağlı
   değildir.

   GÖRÜNÜRLÜK GARANTİLERİ
   · `width`/`height` ÖZNİTELİK olarak veriliyor — CSS hiç yüklenmese bile
     boyut var, sıfır piksele düşmüyor.
   · `flex: 0 0 auto` satır içi stil ile — dar ekranda esnek kutu bayrağı
     ezip genişliğini sıfırlayamaz (Tailwind yüklenmese de geçerli).
   · İnce bir kenar çizgisi (`wsKenar`) beyaz alanların açık zeminde
     kaybolmasını engelliyor.
   · `aria-hidden` — düğmenin kendi `aria-label`ı zaten dili söylüyor; ekran
     okuyucunun aynı bilgiyi iki kez okuması gerekmiyor.
   · `focusable="false"` — eski Edge/IE SVG'yi sekme sırasına sokuyordu.
   ========================================================================== */

/* ABD bayrağındaki 50 yıldızın tamamı. 9 satır (6-5-6-5-6-5-6-5-6), resmi
   yerleşim: satır aralığı kanton yüksekliğinin 1/10'u, sütun aralığı kanton
   genişliğinin 1/12'si, yıldız çapı bayrak yüksekliğinin 0,0616'sı.
   Her yıldız kendi alt yolu; dolgu kuralı `nonzero` beş köşeli dolu yıldız
   üretiyor. */
const ABD_YILDIZLARI =
  'M38.00 13.83L27.14 47.26L55.58 26.60L20.42 26.60L48.86 47.26ZM114.00 13.83L103.14 47.26L131.58 26.60L96.42 26.60L124.86 47.26ZM190.00 13.83L179.14 47.26L207.58 26.60L172.42 26.60L200.86 47.26ZM266.00 13.83L255.14 47.26L283.58 26.60L248.42 26.60L276.86 47.26ZM342.00 13.83L331.14 47.26L359.58 26.60L324.42 26.60L352.86 47.26ZM418.00 13.83L407.14 47.26L435.58 26.60L400.42 26.60L428.86 47.26ZM76.00 46.14L65.14 79.57L93.58 58.90L58.42 58.90L86.86 79.57ZM152.00 46.14L141.14 79.57L169.58 58.90L134.42 58.90L162.86 79.57ZM228.00 46.14L217.14 79.57L245.58 58.90L210.42 58.90L238.86 79.57ZM304.00 46.14L293.14 79.57L321.58 58.90L286.42 58.90L314.86 79.57ZM380.00 46.14L369.14 79.57L397.58 58.90L362.42 58.90L390.86 79.57ZM38.00 78.44L27.14 111.87L55.58 91.21L20.42 91.21L48.86 111.87ZM114.00 78.44L103.14 111.87L131.58 91.21L96.42 91.21L124.86 111.87ZM190.00 78.44L179.14 111.87L207.58 91.21L172.42 91.21L200.86 111.87ZM266.00 78.44L255.14 111.87L283.58 91.21L248.42 91.21L276.86 111.87ZM342.00 78.44L331.14 111.87L359.58 91.21L324.42 91.21L352.86 111.87ZM418.00 78.44L407.14 111.87L435.58 91.21L400.42 91.21L428.86 111.87ZM76.00 110.75L65.14 144.18L93.58 123.52L58.42 123.52L86.86 144.18ZM152.00 110.75L141.14 144.18L169.58 123.52L134.42 123.52L162.86 144.18ZM228.00 110.75L217.14 144.18L245.58 123.52L210.42 123.52L238.86 144.18ZM304.00 110.75L293.14 144.18L321.58 123.52L286.42 123.52L314.86 144.18ZM380.00 110.75L369.14 144.18L397.58 123.52L362.42 123.52L390.86 144.18ZM38.00 143.06L27.14 176.49L55.58 155.83L20.42 155.83L48.86 176.49ZM114.00 143.06L103.14 176.49L131.58 155.83L96.42 155.83L124.86 176.49ZM190.00 143.06L179.14 176.49L207.58 155.83L172.42 155.83L200.86 176.49ZM266.00 143.06L255.14 176.49L283.58 155.83L248.42 155.83L276.86 176.49ZM342.00 143.06L331.14 176.49L359.58 155.83L324.42 155.83L352.86 176.49ZM418.00 143.06L407.14 176.49L435.58 155.83L400.42 155.83L428.86 176.49ZM76.00 175.37L65.14 208.80L93.58 188.14L58.42 188.14L86.86 208.80ZM152.00 175.37L141.14 208.80L169.58 188.14L134.42 188.14L162.86 208.80ZM228.00 175.37L217.14 208.80L245.58 188.14L210.42 188.14L238.86 208.80ZM304.00 175.37L293.14 208.80L321.58 188.14L286.42 188.14L314.86 208.80ZM380.00 175.37L369.14 208.80L397.58 188.14L362.42 188.14L390.86 208.80ZM38.00 207.67L27.14 241.10L55.58 220.44L20.42 220.44L48.86 241.10ZM114.00 207.67L103.14 241.10L131.58 220.44L96.42 220.44L124.86 241.10ZM190.00 207.67L179.14 241.10L207.58 220.44L172.42 220.44L200.86 241.10ZM266.00 207.67L255.14 241.10L283.58 220.44L248.42 220.44L276.86 241.10ZM342.00 207.67L331.14 241.10L359.58 220.44L324.42 220.44L352.86 241.10ZM418.00 207.67L407.14 241.10L435.58 220.44L400.42 220.44L428.86 241.10ZM76.00 239.98L65.14 273.41L93.58 252.75L58.42 252.75L86.86 273.41ZM152.00 239.98L141.14 273.41L169.58 252.75L134.42 252.75L162.86 273.41ZM228.00 239.98L217.14 273.41L245.58 252.75L210.42 252.75L238.86 273.41ZM304.00 239.98L293.14 273.41L321.58 252.75L286.42 252.75L314.86 273.41ZM380.00 239.98L369.14 273.41L397.58 252.75L362.42 252.75L390.86 273.41ZM38.00 272.29L27.14 305.72L55.58 285.06L20.42 285.06L48.86 305.72ZM114.00 272.29L103.14 305.72L131.58 285.06L96.42 285.06L124.86 305.72ZM190.00 272.29L179.14 305.72L207.58 285.06L172.42 285.06L200.86 305.72ZM266.00 272.29L255.14 305.72L283.58 285.06L248.42 285.06L276.86 305.72ZM342.00 272.29L331.14 305.72L359.58 285.06L324.42 285.06L352.86 305.72ZM418.00 272.29L407.14 305.72L435.58 285.06L400.42 285.06L428.86 305.72Z';

/* Ortak ölçüler. Her iki bayrak da 3:2 kutuda çiziliyor — ABD bayrağının
   resmi oranı 1,9:1'dir ama iki bayrak yan yana kullanılmıyor; ortak orana
   çekmek, düğme genişliğinin dile göre oynamasını engelliyor. */
const KUTU_EN = 900;
const KUTU_BOY = 600;

function olcu(en) {
  const g = Number.isFinite(en) && en > 0 ? en : 20;
  return { g, y: Math.round((g * KUTU_BOY) / KUTU_EN * 100) / 100 };
}

function ortakOzellikler(g, y) {
  return {
    width: g,
    height: y,
    viewBox: `0 0 ${KUTU_EN} ${KUTU_BOY}`,
    xmlns: 'http://www.w3.org/2000/svg',
    preserveAspectRatio: 'xMidYMid meet',
    'aria-hidden': 'true',
    focusable: 'false',
    style: { display: 'block', flex: '0 0 auto', borderRadius: 2 },
  };
}

/* Açık zeminde beyaz alanların kenarını belirginleştiren çizgi. Koyu zeminde
   zaten görünmüyor (siyahın üstünde siyah) ve orada da gerekmiyor. */
function Kenar() {
  return (
    <rect
      x="7"
      y="7"
      width={KUTU_EN - 14}
      height={KUTU_BOY - 14}
      fill="none"
      stroke="rgba(0,0,0,0.28)"
      strokeWidth="14"
    />
  );
}

/**
 * TÜRKİYE BAYRAĞI.
 * Geometri Türk Bayrağı Kanunu ekindeki orana göre: dış daire yarıçapı
 * bayrak yüksekliğinin 1/4'ü, iç daire 1/5'i ve merkezleri arası fark
 * yüksekliğin 1/12'si. Yıldızın bir ucu hilalin boşluğuna, yani SOLA bakar.
 */
export function BayrakTR({ en = 20 }) {
  const { g, y } = olcu(en);
  return (
    <svg {...ortakOzellikler(g, y)}>
      <rect width={KUTU_EN} height={KUTU_BOY} fill="#E30A17" />
      <circle cx="425" cy="300" r="150" fill="#FFFFFF" />
      <circle cx="475" cy="300" r="120" fill="#E30A17" />
      <path
        fill="#FFFFFF"
        d="M583.334 300l180.902 58.779-111.804-153.885v190.212l111.804-153.885z"
      />
      <Kenar />
    </svg>
  );
}

/**
 * AMERİKA BİRLEŞİK DEVLETLERİ BAYRAĞI.
 * Selçuk'un açık talimatı: İngilizce için Birleşik Krallık değil ABD bayrağı.
 * 13 şerit (7 kırmızı, 6 beyaz), kanton 7 şerit yüksekliğinde ve bayrak
 * yüksekliğinin 0,76'sı genişliğinde, içinde 50 yıldız.
 */
export function BayrakUS({ en = 20 }) {
  const { g, y } = olcu(en);
  const serit = KUTU_BOY / 13;
  return (
    <svg {...ortakOzellikler(g, y)}>
      {/* Zemin kırmızı; beyaz şeritler üstüne çiziliyor. Tersi 7 dikdörtgen
          gerektirirdi, bu 6 ile bitiyor. */}
      <rect width={KUTU_EN} height={KUTU_BOY} fill="#B22234" />
      {[1, 3, 5, 7, 9, 11].map((k) => (
        <rect key={k} y={serit * k} width={KUTU_EN} height={serit} fill="#FFFFFF" />
      ))}
      <rect width={0.76 * KUTU_BOY} height={serit * 7} fill="#3C3B6E" />
      <path fill="#FFFFFF" d={ABD_YILDIZLARI} />
      <Kenar />
    </svg>
  );
}

/**
 * DİLE GÖRE BAYRAK. Bilinmeyen bir dil kodu gelirse ABD bayrağı çiziliyor —
 * `null` dönmek, bayrağın hiç görünmediği bir hâl yaratırdı.
 */
export default function Bayrak({ dil, en = 20 }) {
  return dil === 'tr' ? <BayrakTR en={en} /> : <BayrakUS en={en} />;
}
